import * as yup from 'yup';

export default yup
  .string()
  .min(0)
  .matches(/^\S*$/, 'Cannot contain whitespaces')
  .optional();
